/**
 * Icône d'un simulateur : `simulators.icon` porte soit un emoji, soit une image
 * encodée (data:). Affichée telle quelle, une image encodée déborde en texte
 * sur toute la largeur — vu sur dev avec « Negotiator ».
 */
export function SimIcon({ icon, size = 14, className }: { icon: string | null | undefined; size?: number; className?: string }) {
  if (!icon) return <span className={className}>•</span>;
  if (icon.startsWith("data:") || icon.startsWith("http") || icon.startsWith("/")) {
    return <img src={icon} alt="" width={size} height={size} className={className} style={{ width: size, height: size, objectFit: "contain", display: "inline-block" }} />;
  }
  // Un emoji tient en quelques unités de code ; au-delà, ce n'est pas une icône.
  if (icon.length > 8) return <span className={className}>•</span>;
  return <span className={className}>{icon}</span>;
}
